import { createObservableRef } from '@utils/react';

function createNotifierStore(name) {
  const refs = {
    name,
    toasts: createObservableRef([]),
    dialogs: createObservableRef([]),
    modals: createObservableRef([])
  };
  const actions = {
    addToast(model) {
      refs.toasts.current = [...refs.toasts.current, model];
    },
    addDialog(model) {
      refs.dialogs.current = [...refs.dialogs.current, model];
    },
    addModal(model) {
      refs.modals.current = [...refs.modals.current, model];
    },
    removeToast(id) {
      refs.toasts.current = refs.toasts.current.filter((it) => it.id !== id);
    },
    removeDialog(id) {
      refs.dialogs.current = refs.dialogs.current.filter((it) => it.id !== id);
    },
    removeModal(id) {
      refs.modals.current = refs.modals.current.filter((it) => it.id !== id);
    },
    replaceToast(id, model) {
      refs.toasts.current = refs.toasts.current.map(
        (it) => it.id === id ? model : it
      );
    }
  };
  return {
    refs,
    actions
  };
}

export { createNotifierStore };
//# sourceMappingURL=notifier.store.js.map
